<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8 lg6 xl4>
            <v-card>
              <v-card-text>
                <div class="layout column align-center">
                  <br>
                  <img src="/static/logo.png" alt="Vue Material Admin" width="240">
                  <h3 class="flex my-4 primary--text">Đăng ký tài khoản</h3>
                </div>
                <v-form>
                  <v-stepper v-model="activeStep">
                    <v-stepper-header>
                      <v-stepper-step :complete="activeStep > 1" step="1">Thông tin xe</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step :complete="activeStep > 2" step="2">Thông tin tài khoản</v-stepper-step>
                      <v-divider></v-divider>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <v-form v-model="form.form1Valid" ref="form1" class="form">
                          <v-text-field
                            label="Imei"
                            mask="################"
                            v-model="form.imei"
                            :rules="[validate.required, validate.numeric]"
                            :error-messages="validateString.imei"
                            @change="checkImeiFromServer()"
                          ></v-text-field>
                          <v-text-field
                            label="Biển số xe"
                            v-model="form.plate"
                            :rules="[validate.required]"
                          ></v-text-field>
                          <v-text-field
                            label="Số điện thoại của thiết bị"
                            mask="################"
                            v-model="form.simPhone"
                            :rules="[validate.required, validate.numeric, validate.min]"
                          ></v-text-field>
                          <v-text-field label="Hãng xe" v-model="form.vehicleBrand"></v-text-field>
                          <span>Biểu tượng xe</span>
                          <v-radio-group v-model="form.vehicleType" :rules="[validate.required]">
                            <v-radio label="Xe máy" :value="1"></v-radio>
                            <v-radio label="Xe ôtô" :value="2"></v-radio>
                            <v-radio label="Biểu tượng mũi tên" :value="3"></v-radio>
                          </v-radio-group>
                        </v-form>
                        <div class="right">
                          <v-btn flat to="/login">Quay lại</v-btn>
                          <v-btn color="success" @click="moveNext()">Tiếp tục</v-btn>
                        </div>
                      </v-stepper-content>
                      <v-stepper-content step="2">
                        <v-form v-model="form.form2Valid" ref="form2" class="form">
                          <v-text-field
                            label="Số điện thoại của bạn"
                            mask="################"
                            v-model="form.phone"
                            :rules="[validate.required, validate.numeric]"
                            :error-messages="validateString.phone"
                            @change="checkPhoneFromServer()"
                          ></v-text-field>
                          <v-text-field
                            label="Mật khẩu"
                            v-model="form.password"
                            :rules="[validate.required, validate.min]"
                            :append-icon="isShowPassword ? `visibility_off` : `visibility`"
                            :type="isShowPassword ? `text` : `password`"
                            @click:append="isShowPassword = !isShowPassword"
                          ></v-text-field>
                          <v-text-field
                            label="Họ tên"
                            v-model="form.name"
                            :rules="[validate.required]"
                          ></v-text-field>
                          <v-text-field
                            label="Email"
                            v-model="form.email"
                            :rules="[validate.required, validate.email]"
                            :error-messages="validateString.email"
                            @change="checkEmailFromServer()"
                          ></v-text-field>
                          <v-text-field label="Địa chỉ" v-model="form.address"></v-text-field>
                        </v-form>
                        <div class="right">
                          <v-btn flat @click="activeStep = 1">Quay lại</v-btn>
                          <v-btn color="success" :loading="isLoading" @click="submit()">Hoàn thành</v-btn>
                        </div>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    activeStep: 0,
    isLoading: false,
    validate: validate,
    isShowPassword: false,
    validateString: {
      imei: '',
      phone: '',
      email: ''
    },
    form: {
      form1Valid: false,
      form2Valid: false,
      imei: '',
      plate: '',
      simPhone: '',
      vehicleBrand: '',
      vehicleType: 1,
      name: '',
      phone: '',
      email: '',
      password: '',
      address: ''
    }
  }),
  methods: {
    ...mapActions([
      'register',
      'checkImei',
      'checkPhone',
      'checkEmail',
      'loginByUsername'
    ]),
    checkImeiFromServer () {
      if (this.form.imei && validate.numeric(this.form.imei)) {
        this.checkImei(this.form.imei)
          .then(result => {
            this.validateString.imei = '';
          })
          .catch(result => {
            this.validateString.imei =
              result.code === 'ERR_IMEI_NOT_EXIST'
                ? 'Số Imei không tồn tại trong hệ thống'
                : result.code === 'ERR_IMEI_USED'
                  ? 'Số Imei đã được sử dụng'
                  : '';
          });
      }
    },
    checkPhoneFromServer () {
      if (this.form.phone && validate.numeric(this.form.phone)) {
        this.checkPhone(this.form.phone)
          .then(result => {
            this.validateString.phone = '';
          })
          .catch(result => {
            this.validateString.phone =
              result.code === 'ERR_INVALID_PHONENUMBER'
                ? 'Số điện thoại không đúng định dạng'
                : result.code === 'ERR_PHONENUMBER_USED'
                  ? 'Số điện thoại đã được sử dụng'
                  : '';
          });
      }
    },
    checkEmailFromServer () {
      if (this.form.email && validate.numeric(this.form.email)) {
        this.checkEmail(this.form.email)
          .then(result => {
            this.validateString.email = '';
          })
          .catch(result => {
            this.validateString.email =
              result.code === 'ERR_EMAIL_NOT_EXIST'
                ? 'Email không tồn tại trong hệ thống'
                : result.code === 'ERR_EMAIL_USED'
                  ? 'Email đã được sử dụng'
                  : '';
          });
      }
    },
    moveNext () {
      if (this.form.form1Valid) {
        this.activeStep = 2;
      } else {
        this.$refs.form1.validate();
      }
    },
    login (model) {
      this.loginByUsername(model)
        .then(() => {
          this.$router.push({ path: '/' });
        })
        .catch(_ => {
          window.getApp.showMessage(
            'Có lỗi xảy ra, quý khách vui lòng đăng nhập thủ công vào hệ thống',
            'error'
          );
          window.location.href = '#/login';
        });
    },
    submit () {
      if (this.form.form1Valid && this.form.form2Valid) {
        this.isLoading = true;
        this.register(this.form)
          .then(res => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Đăng ký thành công, đang đăng nhập vào hệ thống'
            );
            let model = {
              username: this.form.phone,
              password: this.form.password
            };
            this.login(model);
            this.form = {
              vehicleType: 1
            };
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Đăng ký tài khoản thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.form2.validate();
      }
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.login-btn {
  color: white !important;
}
.v-card__text {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}
.form {
  min-height: 200px;
}
p {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue